<template>
  <!-- メッセージエリア -->
  <div id="messages">
    <!-- Infoメッセージ-->
    <v-snackbar
      v-model="isShowInfo"
      :right="true"
      :timeout="timeout"
      :top="true"
      :color="message.color"
      multi-line
      class="white--text fs-x-medium f-family-hiragino"
    >
      {{ message.info }}
      <v-icon right color="white" @click="clearMessages">clear</v-icon>
    </v-snackbar>

    <!-- Warningメッセージ-->
    <LabelDialog v-model="isShowWarnings" warning>
      <template #dialog-title>
        {{ message.title }}
      </template>

      <template #dialog-message>{{ message.warnings }}</template>

      <template #dialog-action>
        <v-layout column>
          <v-layout justify-end>
            <Button width="100" primary @click.native="isShowWarnings = !isShowWarnings">OK </Button>
          </v-layout>
        </v-layout>
      </template>
    </LabelDialog>

    <!-- Errorメッセージ-->
    <LabelDialog v-model="isShowError" error>
      <template #dialog-title>
        {{ message.title }}
      </template>

      <template #dialog-message>{{ message.error }}</template>

      <template #dialog-action>
        <v-layout column>
          <v-layout justify-end>
            <Button width="100" primary @click.native="isShowError = !isShowError">OK </Button>
          </v-layout>
        </v-layout>
      </template>
    </LabelDialog>

    <!-- バージョンアップロード完了メッセージ-->
    <v-snackbar
      v-model="isShowNewVersionUploaded"
      :right="true"
      :top="true"
      :timeout="1000 * 60 * 60 * 12"
      multi-line
      class="white--text f-family-hiragino new-version-uploaded"
    >
      <v-icon class="info-icon">info</v-icon>
      <div>
        最新のバージョンの登録準備が完了しました。<br />
        <a href="#" @click.prevent="versionUploadedUrlClicked()">こちら</a>をクリックして登録を完了してください。
      </div>
      <v-icon right color="white" @click="clearMessages">clear</v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import Button from '@/components/_atoms/buttons/Button.vue';
import LabelDialog from '@/components/_molecules/LabelDialog.vue';
import UnreadUserContractScenario from '@/api/user_contract/unread_user_contract/scenario.js';

export default {
  components: { Button, LabelDialog },
  data() {
    return {
      timeout: 6000
    };
  },
  computed: {
    message: function() {
      return this.$store.state.message;
    },
    isShowInfo: {
      get() {
        return this.$store.getters['message/isShowInfo'];
      },
      set() {
        this.$store.dispatch('message/clearMessages');
      }
    },
    isShowWarnings: {
      get() {
        return this.$store.getters['message/isShowWarnings'];
      },
      set() {
        this.$store.dispatch('message/clearMessages');
      }
    },
    isShowError: {
      get() {
        return this.$store.getters['message/isShowError'];
      },
      set() {
        this.$store.dispatch('message/clearMessages');
      }
    },
    isShowNewVersionUploaded: {
      get() {
        return this.$store.getters['message/isShowNewVersionUploaded'];
      },
      set() {
        this.$store.dispatch('message/clearMessages');
      }
    },
    userContractHeadIdOfNewVersion: function() {
      return this.$store.getters['message/userContractHeadIdOfNewVersion'];
    }
  },
  methods: {
    clearMessages() {
      this.$store.dispatch('message/clearMessages');
    },
    versionUploadedUrlClicked() {
      // 遷移してすぐリスクチェックが走る仕様なので、既読フラグを削除できる
      UnreadUserContractScenario.deleteUnreadUserContract(this.userContractHeadIdOfNewVersion).then(() => {
        const url = new URL(window.location.href);
        this.clearMessages();
        window.location.href = url.href;
      });
    }
  }
};
</script>

<style scoped>
.info-icon {
  color: white;
  font-size: 32px;
  margin-right: 12px;
}

.new-version-uploaded {
  position: fixed;
  top: 0;
  right: 0;
  font-size: 14px;
  white-space: nowrap;
}

.new-version-uploaded a {
  color: white;
  text-decoration: underline;
}

.new-version-uploaded >>> .v-snack__content {
  background-color: #26539a;
  height: 72px;
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/_organisms/CommonMessage.vue